import { Directive, HostListener, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { RutValidator } from '../validators/rut.validator';

/**
 * Directiva que formatea automáticamente un RUT chileno mientras el usuario escribe.
 * Delega el formato a RutValidator.format() para mantener una única fuente de verdad.
 *
 * Uso: <input matInput formControlName="dni" pgsRutFormat>
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[pgsRutFormat]'
})
export class PgsRutFormatDirective {

  constructor(@Self() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cursor = input.selectionStart;
    const rawLength = input.value.length;

    const formatted = RutValidator.format(input.value);
    this.ngControl.control.setValue(formatted, { emitEvent: true });

    // Reposicionar cursor compensando caracteres insertados (puntos / guión)
    const added = formatted.length - rawLength;
    const newCursor = Math.max(0, cursor + added);
    requestAnimationFrame(() => input.setSelectionRange(newCursor, newCursor));
  }

  @HostListener('blur')
  onBlur(): void {
    const val = (this.ngControl.value || '') as string;
    const formatted = RutValidator.format(val);
    if (formatted !== val) {
      this.ngControl.control.setValue(formatted, { emitEvent: true });
    }
  }
}


